module.exports = __webpack_public_path__ + "static/media/received_1747723315295641.08f08375.jpg";